module.exports = __webpack_public_path__ + "img/logo.2dcf744d.svg";